<template>
  <div class="dialog-wrap">
    <el-dialog
      title="详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="784px"
    >
      <div class="main">
        <div class="item">
          <div class="label">模板类型</div>
          <div class="value">{{formateType(this.content.TemplateType)}}</div>
        </div>
        <div class="item">
          <div class="label">模板名称</div>
          <div class="value">{{this.content.TemplateName}}</div>
        </div>
        <div class="item">
          <div class="label">模板CODE</div>
          <div class="value">{{this.content.TemplateCode}}</div>

        </div>
        <div class="item">
          <div class="label">模板内容</div>
          <div class="value">{{this.content.TemplateContent}}</div>
        </div>
        <!--     <div class="item">
          <div class="label">关联签名</div>
          <div class="value">{{this.content.TemplateName}}</div>
        </div> -->
        <div class="item">
          <div class="label">创建人</div>
          <div class="value">{{this.content.creator?this.content.creator.nickname:'暂无'}}</div>
        </div>
        <div class="item">
          <div class="label">创建时间</div>
          <div class="value">{{this.content.CreateDate}}</div>
        </div>
      </div>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleClose"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>


export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      console.log(this.content);
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    formateType(type) {
      let obj = {
        '0': '验证码',
        '1': '短信通知',
        '2': '推广短信',
        '3': '国际/港澳台消息',
      }
      return obj[type]
    }
  }
}
  </script>
  
  <style lang="less" scoped>
.main {
  .item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 18px;
    .label {
      width: 120px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .value {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
    }
  }
}
</style>
  